import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useState, type ReactNode } from 'react'

import { ApiError } from '@/shared/api/client'
import { ToastHost } from '@/shared/ui/ToastHost'

export function Providers({ children }: { children: ReactNode }) {
  const [client] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            // мобильная сеть рвётся постоянно: пара повторов лучше пустого экрана,
            // но 401 и 403 повторять бессмысленно
            retry: (failureCount, error) => {
              if (error instanceof ApiError && (error.isAuth || error.status === 403)) return false
              return failureCount < 2
            },
            refetchOnWindowFocus: true,
            staleTime: 10_000,
          },
          mutations: { retry: 0 },
        },
      }),
  )

  return (
    <QueryClientProvider client={client}>
      {children}
      <ToastHost />
    </QueryClientProvider>
  )
}
